<template>
  <li>
    <div
      class="parent mb-1"
      :class="{
        selected: isSelected
      }"
    >
      <span class="pt-1">
        <vs-icon
          size="small"
          icon="keyboard_arrow_right"
          v-if="!isOpen"
          @click="toggle"
          style="color: orange"

        />
        <vs-icon
          size="small"
          icon="keyboard_arrow_down"
          v-if="isOpen"
          @click="toggle"
        />
      </span>
      <span
        class="pt-1"
        @click="selectFolder()"
      >
        <font-awesome-icon
          :icon="['fas', 'folder']"
          v-if="!isOpen"
          :style="{
            color: folder.blockEdit ? 'red' : 'orange'
          }"/>
        <font-awesome-icon
          :icon="['fas', 'folder-open']"
          v-if="isOpen"
          :style="{
            color: folder.blockEdit ? 'red' : 'orange'
          }"
        />
      </span>
      <span
        class="pt-1 text-sm pl-1"
        @click="selectFolder()"
      >
        {{ folder.nombre }}
      </span>
      <span class="spinner-grow spinner-grow-sm text-purple h-4 w-4 mt-2 ml-2"
            v-show="loading"
      />
    </div>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <ul v-if="isOpen" class="border-0 border-l-2 border-double left-0 pl-3 border-grey-light">
        <folders-tree
          v-for="folder in subFolders"
          :folder="folder"
          :key="folder.carpetaId"
          :repository-id="repositoryId"
        />
      </ul>
    </transition>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div class="w-100 mt-3" v-show="loading">
        <b-skeleton class="bg-grey-light border-0 w-48 h-8 mb-3" type="input" animation="fade"/>
        <b-skeleton class="bg-grey-light border-0 w-32 h-8 mb-3" type="input" animation="fade"/>
        <b-skeleton class="bg-grey-light border-0 w-64 h-8 mb-3" type="input" animation="fade"/>
        <div class="d-flex w-100">
          <b-skeleton class="bg-grey-light border-0 w-3 h-3 ml-3" type="text" animation="fade"/>
          <b-skeleton class="bg-grey-light border-0 w-3 h-3 ml-1" type="text" animation="fade"/>
          <b-skeleton class="bg-grey-light border-0 w-3 h-3 ml-1" type="text" animation="fade"/>
        </div>
      </div>
    </transition>
  </li>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFolder, faFolderOpen } from '@fortawesome/free-solid-svg-icons';

library.add(faFolder, faFolderOpen);

export default {
  name: 'folders-tree',
  props: {
    folder: Object,
    repositoryId: String
  },
  data() {
    return {
      isSelected: false,
      isOpen: false,
      subFolders: [],
      loading: false
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      if (this.isEmptyFolder) {
        this.selectFolder();
      }
    },
    selectFolder() {
      const fullpath = `${this.folder.repositoryId
      + (this.folder.fullpathId === '/' ? '' : this.folder.fullpathId)
      }/${this.folder.carpetaId}`;
      const { name } = this.$route;
      if (name === 'document-management') {
        window.history.pushState(
          {},
          null,
          `${this.$route.path}#/${fullpath}`
        );
      } else {
        // console.log('NO CAMBIO URL');
      }
      this.getFolders();
    },
    async getFolders() {
      this.loading = true;
      this.isOpen = true;
      await this.setSelectedFolderId(this.folder.carpetaId);
      Promise.all([
        this.loadTree({
          repositoryId: this.repositoryId,
          parentFolder: this.folder.carpetaId,
          path: `${this.folder.fullpathId}/${this.folder.carpetaId}`
        }),
        this.loadFiles({
          repositoryId: this.repositoryId,
          parentFolder: this.folder.carpetaId,
          path: this.folder.carpetaId
        })
      ]).then(() => {
        this.loading = false;
        if (this.isEmptyFolder) {
          this.isOpen = false;
        }
      });
    },
    ...mapActions('DocManagement', [
      'loadTree',
      'loadFiles',
      'setSelectedFolderId'
    ])
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedFolderId',
      'getTreeElements'
    ]),
    isEmptyFolder() {
      if (!this.loading) {
        if (!this.subFolders.length) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    const ids = window.location.hash.split('/');
    if (ids.includes(this.folder.carpetaId)) {
      this.getFolders();
    }
    const that = this;
    this.$root.$on('open-folder', (folderId) => {
      // your code goes here
      if (that.folder.carpetaId === folderId) {
        that.selectFolder();
      }
    });
  },
  watch: {
    getSelectedFolderId(val) {
      if (val === this.folder.carpetaId) {
        this.isSelected = true;
      } else {
        this.isSelected = false;
      }
    },
    getTreeElements(val) {
      if (this.isSelected) {
        this.subFolders = Object.values(val).filter((element) => (
          element.parentFolder === this.folder.carpetaId
        ));
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.item {
  cursor: pointer;
  list-style: none;
}

.parent {
  font-weight: bold;
}

ul {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 1em;
  line-height: 1.5em;
}

li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.selected {
  border-radius: 5px;
  width: fit-content;
  padding-right: 10px;
  color: #323e48;
  background: #671e853d;
}
</style>
